"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldFocusContext = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const react_1 = require("react");
const EMPTY_FIELD_ID = null;
const createUniqueFieldId = () => [];
const FOCUS_CHANGE_EVENT = 'focus-change';
const createContextValue = () => {
    const event = new eventemitter3_1.default();
    return {
        subscribe(listener) {
            event.on(FOCUS_CHANGE_EVENT, listener);
        },
        unsubscribe(listener) {
            event.off(FOCUS_CHANGE_EVENT, listener);
        },
        onFocusField(fieldId) {
            event.emit(FOCUS_CHANGE_EVENT, fieldId);
        },
        onBlurField() {
            event.emit(FOCUS_CHANGE_EVENT, EMPTY_FIELD_ID);
        },
    };
};
const FieldFocusContext = react_1.createContext(createContextValue());
exports.useFieldFocusContext = () => {
    const { subscribe, unsubscribe, onFocusField, onBlurField } = react_1.useContext(FieldFocusContext);
    const fieldId = react_1.useMemo(createUniqueFieldId, []);
    const [isMuted, setMuted] = react_1.useState(false);
    const [isFocused, setFocused] = react_1.useState(false);
    const onFieldFocusChange = react_1.useCallback(focusedFieldId => {
        setMuted(focusedFieldId !== fieldId && focusedFieldId !== EMPTY_FIELD_ID);
    }, [fieldId]);
    const onFocus = react_1.useCallback(() => {
        onFocusField(fieldId);
        setFocused(true);
    }, [fieldId, onFocusField]);
    const onBlur = react_1.useCallback(() => {
        onBlurField(fieldId);
        setFocused(false);
    }, [fieldId, onBlurField]);
    react_1.useEffect(() => {
        subscribe(onFieldFocusChange);
        return () => {
            if (isFocused) {
                onBlurField();
            }
            unsubscribe(onFieldFocusChange);
        };
    }, [
        fieldId,
        isFocused,
        onBlurField,
        onFieldFocusChange,
        subscribe,
        unsubscribe,
    ]);
    return {
        isMuted,
        onFocus,
        onBlur,
    };
};
